import _regeneratorRuntime from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/Users/lucky.zhang/workspaces/workspace_go/src/routerman/web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.map.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.ends-with.js";
import "core-js/modules/es.array.join.js";
import { batchCreateDomain, updateDomainRR } from "@/api/domain";
import { parseZone } from "dnszen";
import { transRRs2Regions, regionToView } from '@/utils/viewinfo';
import { checkDomain, isIPv4, isIPv6 } from '@/utils/stringFun';
export default {
  name: "DomainImport",
  data: function data() {
    return {
      qZone: this.$route.query.zone,
      importContent: '',
      rrs: [],
      total: 0,
      page: 1,
      pageSize: 50,
      contentErr: [],
      contentErrType: 'error',
      regions: [],
      allRRs: []
    };
  },
  computed: {
    recordPreViewTitle: function recordPreViewTitle() {
      return this.$t('domain.import-table-title-pre') + this.qZone + this.$t('domain.import-table-title-suf') + ' (' + this.total + ')';
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.push({
        name: "zoneDetail",
        query: {
          zone: this.qZone
        }
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getTableData();
    },
    getTableData: function getTableData() {
      this.total = this.allRRs.length;
      if (this.page == 0) {
        this.page == 1;
      }
      var start = (this.page - 1) * this.pageSize;
      this.rrs = this.allRRs.slice(start, start + this.pageSize);
      console.log(this.rrs);
    },
    validateForm: function validateForm(recordObj, isPrimaryDomain) {
      var _recordObj$region,
        _this = this;
      var err = [];
      if (!recordObj.default.names || recordObj.default.names.length == 0) {
        err.push(this.$t('domain.validate-no-default-region'));
        return err;
      }
      err = this.validateRegion(recordObj.default, isPrimaryDomain);
      (_recordObj$region = recordObj.region) === null || _recordObj$region === void 0 ? void 0 : _recordObj$region.forEach(function (region) {
        var smartErr = _this.validateRegion(region, isPrimaryDomain);
        err = [].concat(_toConsumableArray(err), _toConsumableArray(smartErr));
      });
      return err;
    },
    validateRegion: function validateRegion(region, isPrimaryDomain) {
      var _this2 = this;
      var err = [];
      if (!region.names || region.names.length == 0) {
        err.push(this.$t('domain.validate-no-region'));
      }
      var _typeMap = new Map();
      var valueMap = new Map();
      var masterRecCount = 0;
      var hc_masterRecCount = 0;
      var slaverRecCount = 0;
      var tplId = 0;
      region.targets.forEach(function (target) {
        target.priority = target.priority || 0;
        if (!_typeMap.has(target.priority)) {
          _typeMap.set(target.priority, target.type);
        }
        if (target.value == '') {
          err.push(_this2.$t('domain.validate-no-value'));
          return true;
        }
        if (valueMap.has(target.value) && valueMap.get(target.value) == target.type) {
          err.push(_this2.$t('domain.validate-exists-value') + ' [' + target.value + ']');
          return true;
        }
        valueMap.set(target.value, target.type);

        // 主记录
        if (target.priority == 0) {
          masterRecCount++;
          if ((target.type == 'A' || target.type == 'AAAA') && target.isHc) {
            hc_masterRecCount++;
          }
        }
        if (target.priority == 1) {
          slaverRecCount++;
        }
        if (target.isHc) {
          if (target.hc.tplId == 0) {
            err.push(_this2.$t('domain.validate-no-select-hc-tpl'));
            return true;
          }
          if (tplId != 0 && target.hc.tplId != tplId) {
            err.push(_this2.$t('domain.validate-diff-hc-tpl'));
            return true;
          }
          tplId = target.hc.tplId;
        }
        if (target.ttl < 60 || target.ttl > 604800) {
          err.push(_this2.$t('domain.validate-ttl-scope') + ' [' + target.ttl + ']');
        }
        if (target.type == '') {
          err.push(_this2.$t('domain.validate-no-type'));
        } else if (target.type == 'CNAME') {
          // 判断域名是否正确
          if (!checkDomain(target.value) || isIPv4(target.value)) {
            err.push(target.type + _this2.$t('domain.validate-invalid-value') + ' [' + target.value + ']');
          }

          // 判断类型并存
          if (_typeMap.get(target.priority) != target.type) {
            err.push(target.type + _this2.$t('domain.validate-coexist-type'));
          }
        } else if (target.type == 'NS') {
          // 判断域名是否正确
          if (!checkDomain(target.value) || isIPv4(target.value)) {
            err.push(target.type + _this2.$t('domain.validate-invalid-value') + ' [' + target.value + ']');
          }

          // 判断类型并存
          if (!isPrimaryDomain && _typeMap.get(target.priority) != target.type) {
            err.push(target.type + _this2.$t('domain.validate-coexist-type'));
          }
        } else {
          if (target.type == 'A') {
            // 判断ip是否正确
            if (!isIPv4(target.value)) {
              err.push(target.type + _this2.$t('domain.validate-invalid-value') + ' [' + target.value + ']');
            }
            if (target.weight < 0 || target.weight > 10) {
              err.push(_this2.$t('domain.validate-weight-scope') + ' [' + target.weight + ']');
            }
          } else if (target.type == 'AAAA') {
            // 判断ip是否正确
            if (!isIPv6(target.value)) {
              err.push(target.type + _this2.$t('domain.validate-invalid-value') + ' [' + target.value + ']');
            }
          } else if (target.type == 'PTR') {
            // 判断ip是否正确
            if (!checkDomain(target.value) || isIPv4(target.value)) {
              err.push(target.type + _this2.$t('domain.validate-invalid-value') + ' [' + target.value + ']');
            }
          }
          // 判断类型并存
          if (_typeMap.get(target.priority) == 'CNAME') {
            err.push(target.type + _this2.$t('domain.validate-coexist-cname'));
          }
          if (!isPrimaryDomain && _typeMap.get(target.priority) == 'NS') {
            err.push(target.type + _this2.$t('domain.validate-coexist-ns'));
          }
        }
      });
      if (slaverRecCount > 0 && (masterRecCount != hc_masterRecCount || masterRecCount == 0)) {
        err.push(this.$t('domain.validate-need-set-master'));
      }
      return err;
    },
    setRecord: function setRecord() {
      var _this3 = this;
      this.regions = [];
      this.allRRs = [];
      this.rrs = [];
      this.total = 0;
      this.contentErr = [];
      var zoneData = parseZone(this.importContent);
      console.log(zoneData);
      var _origin = zoneData.origin;
      if (_origin && _origin != '' && _origin != this.qZone) {
        this.contentErr = [this.$t('domain.import-error-zone')];
        this.contentErrType = "error";
        return;
      }
      var _support_type = ['A', 'AAAA', 'CNAME', 'MX', 'TXT', 'NS', 'SRV', 'CAA', 'SPF', 'NAPTR', 'PTR'];
      var errors = [];
      var _rrs = zoneData.records.filter(function (rr) {
        if (rr.type == 'SOA') {
          errors.push(_this3.$t('domain.import-error-soa'));
          return false;
        }
        if ((rr.name == '' || rr.name == '.' || rr.name == '@' || rr.name == _this3.qZone) && rr.type.toUpperCase() == 'NS') {
          errors.push(rr.name + ": " + _this3.$t('domain.import-error-pdomain-ns'));
          return false;
        }
        if (rr.name == '' || rr.name == '.' || rr.name == '@') {
          rr.name = _this3.qZone;
        }
        if (!rr.name.endsWith(_this3.qZone)) {
          rr.name = rr.name + '.' + _this3.qZone;
        }
        if (_support_type.indexOf(rr.type) == -1) {
          errors.push(rr.name + ": " + _this3.$t('domain.import-error-type'));
          return false;
        }
        if (rr.class != 'IN') {
          errors.push(rr.name + ": " + _this3.$t('domain.import-error-class'));
          return false;
        }
        return true;
      });
      if (errors.length > 0) {
        this.contentErr = errors;
        this.contentErrType = "warning";
      }
      if (_rrs.length > 1000) {
        this.contentErr = ["count:" + _rrs.length + ", " + this.$t('domain.import-error-count-limit')];
        this.contentErrType = "error";
        return;
      }
      var errs = [];
      var _regions = transRRs2Regions(_rrs);
      _regions.forEach(function (recordObj, domain) {
        var err = _this3.validateForm(recordObj, false);
        if (err.length > 0) {
          errs.push(domain + ': ' + err.join(','));
        }
      });
      if (errs.length > 0) {
        this.contentErr = errs;
        this.contentErrType = "error";
        return;
      }
      this.regions = _regions;
      // 假分页
      this.allRRs = _rrs;
      this.getTableData();
    },
    saveImport: function saveImport() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var pView, views, _res, res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              pView = undefined;
              views = [];
              _this4.regions.forEach(function (recordObj, domain) {
                // 组织成obj
                var viewObj = regionToView(recordObj, false);
                viewObj['zone'] = _this4.qZone;
                viewObj['name'] = domain;
                viewObj['pause'] = 0;
                if (domain == _this4.qZone) {
                  pView = viewObj;
                } else {
                  views.push(viewObj);
                }
              });
              _this4.fullscreenLoading = true;
              if (!pView) {
                _context.next = 12;
                break;
              }
              _context.next = 7;
              return updateDomainRR(pView);
            case 7:
              _res = _context.sent;
              if (!(_res.code != 0)) {
                _context.next = 12;
                break;
              }
              _this4.isDisabledSaveBtn = false;
              _this4.fullscreenLoading = false;
              return _context.abrupt("return");
            case 12:
              res = {
                code: 0
              };
              if (!(views.length != 0)) {
                _context.next = 17;
                break;
              }
              _context.next = 16;
              return batchCreateDomain(views, _this4.qZone);
            case 16:
              res = _context.sent;
            case 17:
              if (res.code == 0) {
                _this4.$message({
                  type: "success",
                  message: _this4.$t('common.msg.import-success')
                });
                _this4.isDisabledSaveBtn = false;
                _this4.fullscreenLoading = false;
                _this4.goBack();
              }
              _this4.isDisabledSaveBtn = false;
              _this4.fullscreenLoading = false;
            case 20:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    }
  }
};